module.exports = __webpack_public_path__ + "img/stock-3.532e3c40.jpg";